import styled from "styled-components";
import { Flex } from "waapi/waap-ui/components/Flex/Flex.js";

export const FieldContent = styled(Flex)<{
    fullWidth?: boolean;
}>`
    width: ${(props) => (props.fullWidth ? "100%" : "auto")};
`;
